const rules = {
	user: {
		static: [],
	},

	supervisor: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"settings-page:view",
		],
	},
};

export default rules;
